/*
|--------------------------------------------------------------------------
| Utility: alertService.js
| Author: Sayed Ahmed
| Description: Wrapper around SweetAlert for displaying alerts, warnings,
|              confirmations, and notifications with custom options.
|--------------------------------------------------------------------------
*/

import swal from "sweetalert";

const alertService = {
  /**
   * Show a success alert
   * @param {string} title - Title of the alert
   * @param {string} text - Message body
   */
  success: (title = "Success", text = "Operation completed successfully") =>
    swal(title, text, "success"),

  /**
   * Show an error alert
   */
  error: (title = "Error", text = "Something went wrong") =>
    swal(title, text, "error"),

  /**
   * Show a warning alert
   */
  warning: (title = "Warning", text = "") =>
    swal(title, text, "warning"),

  /**
   * Show an info alert
   */
  info: (title = "Info", text = "") =>
    swal(title, text, "info"),

  /**
   * Show a confirmation dialog with custom labels
   * @returns {Promise<boolean>} true if confirmed, false otherwise
   */
  confirm: ({
    title = "Are you sure?",
    text = "You won't be able to revert this!",
    confirmButtonText = "Yes, continue",
    cancelButtonText = "Cancel",
    dangerMode = true,
  } = {}) =>
    swal({
      title,
      text,
      icon: "warning",
      buttons: {
        cancel: cancelButtonText,
        confirm: {
          text: confirmButtonText,
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
      dangerMode,
    }),
};

export default alertService;
